import React from 'react';

import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';

import { ProductLinksCards } from '@src/components/promoCards/layouts/OneThird/ProductLinks';

import './links.scss';

/**
 * ## Links
 *
 * Link components visible products for users
 * @param {array} products - array of products users can view
 */
export const Links = (props) => {
    const {
        products,
    } = props;

    return (
        <Row>
            {
                products.map((product) => {
                    const {
                        name,
                        slug,
                        has_legacy,
                        is_new,
                        platform,
                    } = product;

                    return (
                        <ProductLinksCards
                            key={`links-${slug}`}
                            text={name}
                            link={slug}
                            platform={platform}
                            isNew={is_new}
                            hasLegacy={has_legacy}
                        />
                    );
                })
            }
        </Row>
    );
};

Links.propTypes = {
    products: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        slug: PropTypes.string,
        has_legacy: PropTypes.bool,
        is_new: PropTypes.bool,
        platform: PropTypes.string,
    })),
};

export default Links;
